<span
  class="flex items-center justify-center shrink-0 overflow-hidden bg-gray-100 text-gray-500"
  [class.rounded-full]="round"
  [class.rounded-md]="!round"
  [class.bg-danger-50]="!url && label === 'PDF'"
  [class.text-danger-600]="!url && label === 'PDF'"
  [style.width.px]="size"
  [style.height.px]="size"
  data-testid="file-thumb"
>
  <img
    *ngIf="url && !failed; else tile"
    class="w-full h-full object-cover"
    [src]="url"
    alt=""
    (error)="failed = true"
  />
  <ng-template #tile>
    <span *ngIf="label && size >= 28; else icon" class="text-[10px] font-bold">{{ label }}</span>
    <ng-template #icon><vs-icon name="attachment-02" [size]="size >= 28 ? 16 : 12"></vs-icon></ng-template>
  </ng-template>
</span>
